const initialize = () => {
    // Apply magnific popup to generic video popup class
    $('.popup-video').magnificPopupWithScrollFix({
        type: 'iframe'
    });
};

export default {
    initialize,
};